import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map, share } from 'rxjs/operators';
import { TokenResponse } from './interface';
import { LocalStorageService } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private key = 'TOKEN';
  private token: string | null = null;
  private change$ = new BehaviorSubject<boolean>(true);

  constructor(private store: LocalStorageService) {
  }

  set(token: TokenResponse) {
    if (token.apiToken !== undefined) {
      this.setToken(token.apiToken, true);
    }

    return this;
  }

  refresh(token: TokenResponse) {
    this.setToken(token.apiToken, false);
  }

  clear() {
    this.clearToken();
  }

  changed() {
    return this.change$.pipe(
      filter(changed => changed),
      map(() => this.getToken()),
      share()
    );
  }

  valid() {
    return this.getToken() !== null;
  }

  getToken(): string | null {
    if (!this.hasToken()) {
      return null;
    }

    if (!this.token) {
      this.token = this.store.get(this.key);
    }

    return this.token;
  }

  private setToken(token: string, changed = false) {
    this.token = token;
    this.store.set(this.key, token);
    this.change$.next(changed);
  }

  private hasToken() {
    return this.store.has(this.key);
  }

  private clearToken() {
    this.token = null;
    this.store.remove(this.key);
    this.change$.next(true);
  }
}
